import { render, staticRenderFns } from "./BalanceHistory.icon.vue?vue&type=template&id=25fc49c4&"
import script from "./BalanceHistory.icon.vue?vue&type=script&lang=js&"
export * from "./BalanceHistory.icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports